import {
  ElectricRetailPoi,
  MapLayerProps,
  MapClickGetPois,
} from 'features/mapping/mapping.types';
import { Layer } from 'shared/map-exports';
import { usePoisState } from 'state/usePoisState';
import {
  getSelectedPatternStyle,
  getSelectedStrokeStyle,
} from 'features/mapping/mapping.utils';
import { addVisible } from 'shared/addVisible';
import { getWatchdutyStaticTileUrl } from 'features/mapping/components/layers/layers.utils';
import { useStaticTileCacheDomain } from 'features/mapping/hooks/useStaticTileCacheDomain';
import { BELOW_STREETS_LAYER_ID } from 'features/mapping/styles';
import { VisibilityToggledSource } from '../VisibilityToggledSource';
import {
  ELECTRIC_RETAIL_LAYER_ID,
  ELECTRIC_RETAIL_MAPTILES_DIRECTORY,
  ELECTRIC_RETAIL_SOURCE_DATA_LAYER,
  MIN_ZOOM_VISIBILITY,
} from './constants';
import { layerFillStyle, layerStrokeStyle } from './layerStyles';

type ElectricRetailService = {
  OBJECTID: string;
  NAME: string;
  CUSTOMERS: number;
};

export const electricRetailServiceClickHandler: MapClickGetPois<
  ElectricRetailService
> = (geoJsonFeatures) => {
  return geoJsonFeatures.map((feature) => {
    const electricRetailService: ElectricRetailService = feature.properties;
    const metadata: ElectricRetailPoi = {
      name: electricRetailService.NAME,
      customers: electricRetailService.CUSTOMERS,
    };

    return {
      type: 'electricRetail',
      id: electricRetailService.OBJECTID,
      metadata,
    };
  });
};

export const ElectricRetailServiceLayer = (
  props: MapLayerProps,
): JSX.Element => {
  const { visible } = props;
  const { selectedPoi } = usePoisState();
  const staticTileCacheDomain = useStaticTileCacheDomain();

  const selectedId =
    selectedPoi?.type === 'electricRetail' ? selectedPoi.id! : '';

  const selectedFillStyle = getSelectedPatternStyle({
    idKey: 'OBJECTID',
    selectedId,
    otherLayerProps: {
      minzoom: MIN_ZOOM_VISIBILITY,
      'source-layer': ELECTRIC_RETAIL_SOURCE_DATA_LAYER,
    },
  });

  const selectedStrokeStyle = getSelectedStrokeStyle({
    idKey: 'OBJECTID',
    selectedId,
    otherLayerProps: {
      minzoom: MIN_ZOOM_VISIBILITY,
      'source-layer': ELECTRIC_RETAIL_SOURCE_DATA_LAYER,
    },
  });

  return (
    <VisibilityToggledSource
      url={getWatchdutyStaticTileUrl(
        ELECTRIC_RETAIL_MAPTILES_DIRECTORY,
        staticTileCacheDomain,
      )}
      visible={visible}
    >
      <Layer
        id={ELECTRIC_RETAIL_LAYER_ID}
        beforeId={BELOW_STREETS_LAYER_ID}
        {...addVisible(layerFillStyle, visible)}
      />
      <Layer
        beforeId={BELOW_STREETS_LAYER_ID}
        {...addVisible(layerStrokeStyle, visible)}
      />
      <Layer
        beforeId={BELOW_STREETS_LAYER_ID}
        {...addVisible(selectedFillStyle, visible)}
      />
      <Layer
        beforeId={BELOW_STREETS_LAYER_ID}
        {...addVisible(selectedStrokeStyle, visible)}
      />
    </VisibilityToggledSource>
  );
};
